/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * A summable reference for complex labels
 */
export type LabelSumRef = {
  /**
   * Whether the value is negative. If true, the value will be subtracted from the sum.
   */
  negative?: boolean | undefined;
  /**
   * A reference to a reading or setting.
   */
  ref: Ref;
};

/** @internal */
export const LabelSumRef$inboundSchema: z.ZodType<
  LabelSumRef,
  z.ZodTypeDef,
  unknown
> = z.object({
  negative: types.boolean().default(false),
  ref: Ref$inboundSchema,
});
/** @internal */
export type LabelSumRef$Outbound = {
  negative: boolean;
  ref: Ref$Outbound;
};

/** @internal */
export const LabelSumRef$outboundSchema: z.ZodType<
  LabelSumRef$Outbound,
  z.ZodTypeDef,
  LabelSumRef
> = z.object({
  negative: z.boolean().default(false),
  ref: Ref$outboundSchema,
});

export function labelSumRefToJSON(labelSumRef: LabelSumRef): string {
  return JSON.stringify(LabelSumRef$outboundSchema.parse(labelSumRef));
}
export function labelSumRefFromJSON(
  jsonString: string,
): SafeParseResult<LabelSumRef, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LabelSumRef$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LabelSumRef' from JSON`,
  );
}
